import { render, staticRenderFns } from "./WishAddNew.vue?vue&type=template&id=7eff437d&"
import script from "./WishAddNew.vue?vue&type=script&lang=ts&"
export * from "./WishAddNew.vue?vue&type=script&lang=ts&"
import style0 from "./WishAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eff437d')) {
      api.createRecord('7eff437d', component.options)
    } else {
      api.reload('7eff437d', component.options)
    }
    module.hot.accept("./WishAddNew.vue?vue&type=template&id=7eff437d&", function () {
      api.rerender('7eff437d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/WishAddNew.vue"
export default component.exports